var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('ErrorToast',{attrs:{"id":_vm.errorToastId,"error-message":_vm.error.message,"title":_vm.error.title}}),_c('UnhandledErrorMessager'),_c('VersionToast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }